import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddSectionPageRoutingModule } from './add-section-routing.module';

import { AddSectionPage } from './add-section.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AddSectionPageRoutingModule
  ],
  declarations: [AddSectionPage]
})
export class AddSectionPageModule {}
